import { IllustrationType } from '@diana/core';
import { Stack, Switch, Typography, useTheme } from '@mui/material';
import { ReactNode } from 'react';

interface ITaskDrawerConfigSwitcherProps {
  title: string;
  description: string;
  disabled?: boolean;
  checked: boolean;
  onChange: () => void;
  footerContent?: ReactNode;
  icon: IllustrationType;
}

export const TaskDrawerConfigSwitcher = ({
  title,
  description,
  disabled = false,
  checked,
  onChange,
  footerContent,
  icon: Icon,
}: ITaskDrawerConfigSwitcherProps) => {
  const { palette } = useTheme();

  const iconSx = { width: 20, height: 20 };

  return (
    <Stack gap={0.75} py={0.75}>
      <Stack direction="row" justifyContent="space-between" gap={0.75}>
        <Stack direction="row" gap={0.75}>
          <Icon sx={iconSx} />
          <Stack gap={0.25}>
            <Typography fontSize={14}>{title}</Typography>
            <Typography fontSize={12} color={palette.text.secondary}>
              {description}
            </Typography>
          </Stack>
        </Stack>
        <Switch
          disabled={disabled}
          checked={checked}
          onChange={onChange}
          sx={{
            height: 36,
            width: 56,
            mt: -1,
            py: '7px',
            pl: '12px',
            pr: 0,
            '& .MuiSwitch-switchBase': { p: '9px', mx: '5px' },
          }}
        />
      </Stack>
      {footerContent && (
        <Stack ml={0.75} width="100%">
          {footerContent}
        </Stack>
      )}
    </Stack>
  );
};
